export const CATEGORY_ENDPOINT = "https://demo4507124.mockable.io/categories"
export const PRODUCT_ENDPOINT = "https://demo4507124.mockable.io/products"
export const ACCESS_TOKEN = "ki494034jkjdfsi49e8943iufkljfdkj4oi3uu498usajhasdfoi4jkjfi434"